import { createContext } from "react";
import { englishLanguage } from "./languages/english";

export const LanguageContext = createContext(englishLanguage);
